<!-- 账户余额-->
<template>
  <div class="page" v-cloak>

    <van-nav-bar :border="false" left-arrow fixed title="在线充值" class="on_line_nav_bar" @click-left="onClickLeft" :style="'background: #4177FF; color:#FFFFFF;'"></van-nav-bar>

    <div class="header-b">
      <div class="header-c">
        <p class="title">当前余额(元)</p>
        <h3 class="price">{{balance.total | numToCash}}</h3>
        <p class="tips">温馨提示：此处充值的实际金额也可以在商城消费</p>
      </div>
    </div>

    <h3 class="list-tips">请选择充值金额</h3>

    <div class="center-bander">
      <div :class="['center-bander-item',  ind == radio_active ? 'bc0':'bc1']" v-for="(im, ind) in configList" :key="ind" @click="onSetPrice(im,ind)">
        <p class="price"> {{im.recharge_amt | numToCash}}<span>元</span></p>
        <p class="give-price">
          <span>(赠送：</span>
          {{im.gift_coin | numToCash}}元
          <span>)</span>
        </p>
      </div>
    </div>

    <h3 class="list-tips_n" v-if="newProductList.length > 0"><span>充值298元送价值298元好礼</span> <span>左右滑动查看更多产品 ></span></h3>

    <div class="new-goods-center" v-if="newProductList.length > 0">
      <van-swipe class="new-goods-swipe" :show-indicators="false">
        <van-swipe-item v-for="(imtge, index) in newProductList" :key="index">
          <img-text-block :show-type="'column'" v-for="(item, index) in imtge" :product="item" :key="index"></img-text-block>
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- <van-button type="primary" @click="goPayresult">确认充值</van-button> -->

    <h3 class="list-tips">充值说明</h3>

    <div class="foot-tips">
      <p>1、请选择一个额度充值，务必仔细核对。</p>
      <p>2、充值实时到账，后台不提供退款服务，可在商城中消费。</p>
      <p class="foot-xy">支付即同意 <span @click="goClause">《充值协议》</span></p>
    </div>

    <div class="img-text-row">
      <div class="row-goods-img">
        <img src="../../assets/index/index_icon10.png" alt="" />

        <div class="row-goods-info">
          <p class="row-goods-name"> 零钱抢购</p>
        </div>
      </div>
      <div class="row-goods-right"> 规则介绍 </div>
    </div>

  </div>
</template>

<script type="text/babel">
import wx from "weixin-js-sdk";
import imgTextBlock from "@/components/img-text-block/img-text-block.vue";
export default {
  name: "onLine",
  components: { imgTextBlock },
  props: {},
  data() {
    return {
      balance: {
        gift_amt: 0, //赠送余额
        total: 0, // 余额
        true_amt: 0, // 充值余额
      },
      radio_active: -1,
      pay_active: {},
      configList: [
        // {
        //   id: 1, //配置项id
        //   recharge_amt: "298.00", //充值金额
        //   gift_coin: "20.00", //赠送金额
        //   true_coin: "318.00", //到账金额
        //   remark: "298赠送20", //备注说明
        // },
      ],
      giftList: [
        // {
        //   title: "Baseus/倍思-一拖三数据线", //标题
        //   pic: "https://qiniu.zdyxjx.com/v3/pic/75374758ee3c4adcb8adb23dd0ab88df.jpg ", //图片
        //   price: 299.2, //价格
        // },
      ],

      newProductList: [],
      // lists: [
      //   {
      //     title: "Baseus/倍思-一拖三数据线", //标题
      //     pic: "https://qiniu.zdyxjx.com/v3/pic/75374758ee3c4adcb8adb23dd0ab88df.jpg ", //图片
      //     price: 299.2, //价格
      //   },
      //   {
      //     title: "Baseus/倍思-一拖三数据线", //标题
      //     pic: "https://qiniu.zdyxjx.com/v3/pic/75374758ee3c4adcb8adb23dd0ab88df.jpg ", //图片
      //     price: 299.2, //价格
      //   },
      //   {
      //     title: "Baseus/倍思-一拖三数据线", //标题
      //     pic: "https://qiniu.zdyxjx.com/v3/pic/75374758ee3c4adcb8adb23dd0ab88df.jpg ", //图片
      //     price: 299.2, //价格
      //   },
      //   {
      //     title: "Baseus/倍思-一拖三数据线", //标题
      //     pic: "https://qiniu.zdyxjx.com/v3/pic/75374758ee3c4adcb8adb23dd0ab88df.jpg ", //图片
      //     price: 299.2, //价格
      //   },
      //   {
      //     title: "Baseus/倍思-一拖三数据线", //标题
      //     pic: "https://qiniu.zdyxjx.com/v3/pic/75374758ee3c4adcb8adb23dd0ab88df.jpg ", //图片
      //     price: 299.2, //价格
      //   },
      //   {
      //     title: "Baseus/倍思-一拖三数据线", //标题
      //     pic: "https://qiniu.zdyxjx.com/v3/pic/75374758ee3c4adcb8adb23dd0ab88df.jpg ", //图片
      //     price: 299.2, //价格
      //   },
      // ],
    };
  },
  watch: {
    // aa: {
    //   handler(newValue, oldValue) {
    //     console.log(newValue, oldValue);
    //   },
    //   deep: true, // 深度监听表单
    // },
  },
  created() {},
  mounted() {
    this.getInit();
  },
  methods: {
    getInit() {
      let _this = this;
      _this.$post("/api/recharge_index").then((res) => {
        console.log(res.data, "充值页配置");
        if (res.data && res.data.code == 0) {
          this.balance = res.data.data.balance;
          this.configList = res.data.data.configList;

          let result = [];
          let dataList = res.data.data.giftList;
          if (dataList.length <= 4) {
            _this.newProductList = [dataList];
            console.log(dataList,'dataList');
          } else {
            for (var i = 0; i < dataList.length; i += 4) {
              result.push(dataList.slice(i, i + 4));
            }
            _this.newProductList = result;
            console.log(result,'result');
          }
        }
      });
    },
    // 切换充值类型
    onSetPrice(im, ind) {
      let _this = this;
      console.log(im);
      _this.pay_active = im;
      _this.radio_active = ind;
      this.goPayresult();
    },
    // 支付下单
    goPayresult(info) {
      let _this = this;
      // console.log(info)
      let data = {
        recharge_id: _this.pay_active.id, //充值选项id
        machine_id: "", //扫设备二维码获取，没有传空
      };
      _this
        .$post("/api/recharge", data, data)
        .then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            // console.log(res.data.data.wxParameters)
            let wxParameters = res.data.data.pay;
            // 微信支付
            _this.payWxPrePay(wxParameters);
          } else {
            _this.$toast.fail(res.data.message);
          }
        })
        .catch((err) => {
          //console.log(err.data)
        });
    },
    payWxPrePay(data) {
      let that = this;
      console.log("吊起微信", data);
      // console.log('吊起微信', wx)

      //       if (res.err_msg == "get_brand_wcpay_request:ok") {
      wx.ready(function () {
        wx.chooseWXPay({
          timestamp: data.timeStamp, ////时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
          package: data.package, //这个package是比较坑的他的格式必须是  prepay_id=wx22104854834640694c34f15a1066605800
          signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: data.paySign, // 支付签名
          appId: data.appId, //公众号名称，由商户传入
          success: function (res) {
            // 支付成功后的回调函数
            if (res.errMsg === "chooseWXPay:ok") {
              that.$toast("支付成功！");
              // that.$router.replace({
              //   name: "pay-result",
              //   query: {
              //     isType: 1,
              //   },
              // });
            } else {
              // console.log(res, '已调起,支付失败')
              that.$toast("支付失败！");
              // that.$router.replace({
              //   name: "pay-result",
              //   query: {
              //     isType: 2,
              //   },
              // });
            }
          },
          fail: function (res) {
            // console.log(res, '支付请求失败')
            that.$toast("支付请求失败");
            // that.$router.replace({
            //   name: "pay-result",
            //   query: {
            //     isType: 2,
            //   },
            // });
          },
          cancel: function (res) {
            // console.log(res, '已调起,已取消支付')
            // that.$toast("已调起,已取消支付");
            that.$toast("已取消支付！");
          },
        });
      });
    },

    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    goClause() {
      this.$router.push({ name: "on-line-recharge-clause", query: {} });
    },
  },
};
</script>
<style lang="scss">
.on_line_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
</style>

<style lang="scss" scoped>
.page {
  //   height: 100%;
  width: 100%;
  padding: 0 0 50px 0;
  background-color: #f7f7f7;
  .header-b {
    height: 184px;
    width: 100%;
    background-image: url("../../assets/onLine/online_1.png");
    background-repeat: no-repeat;
    background-size: 100% 130px;
    // background-color: #000;
    padding: 50px 25px 0;

    .header-c {
      height: 130px;
      background: #ffffff;
      border-radius: 10px;
      padding: 15px;
      text-align: left;

      .title {
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .price {
        margin-top: 15px;
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        font-weight: bold;
      }
      .tips {
        margin-top: 15px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: #999999;
      }
    }
  }
  //
  .list-tips {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;

    text-align: left;
    padding: 10px 15px 0;
    overflow: hidden;

    span {
      float: right;
      padding: 5px 10px;
      background: linear-gradient(90deg, #2045e6 0%, #53a0fa 100%);
      border-radius: 10px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .list-tips_n {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;

    text-align: left;
    padding: 10px 15px 0;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span { 
      padding: 5px 10px;
      background: linear-gradient(90deg, #2045e6 0%, #53a0fa 100%);
      border-radius: 10px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
  }

  //
  .center-bander {
    padding: 15px 0 0;
    // background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;

    .center-bander-item {
      box-sizing: border-box;
      width: 45%;
      margin: 0 8px 15px;
      border: 1px solid #f9f9f9;

      border-radius: 12px;
      text-align: center;
      padding: 15px;
      .price {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2998ff;
        span {
          font-size: 12px;
        }
      }
      .give-price {
        margin-top: 5px;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #f22b2b;

        span {
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #999999;
        }
      }
    }

    .bc0 {
      background: #2998ff;
      .price {
        color: #ffffff !important;
      }

      .give-price {
        color: #ffffff !important;
        span {
          color: #ffffff !important;
        }
      }
    }
    .bc1 {
      background: #ffffff;
    }
  }

  .list {
    padding: 0 15px 30px;
  }
}

.new-goods-center {
  padding: 15px 10px;
  //   background-color: green;
  .new-goods-swipe {
    height: 100%;
    width: 100%;
    .van-swipe-item {
      display: flex;
      flex-wrap: wrap;
    }
  }
}

// 底部提示

.foot-tips {
  padding: 15px;
  text-align: left;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;

  .foot-xy {
    margin-top: 30px;
    text-align: center;
    span {
      color: #1cc2ff;
    }
  }
}

// 横向
.img-text-row {
  margin: 15px;
  padding: 15px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .row-goods-img {
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 24px;
      height: 100%;
    }

    .row-goods-info {
      margin-left: 15px;
      padding: 5px 0;
      text-align: left;
      //  background-color: paleturquoise;

      .row-goods-name {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
    }
  }
  .row-goods-right {
    display: inline-block;
    padding: 5px 10px;
    background: rgba(234, 234, 234, 0.6);
    border-radius: 10px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
  }
}

.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
</style>
